import { render, staticRenderFns } from "./BestsellProduct.vue?vue&type=template&id=5e19777b&scoped=true&"
import script from "./BestsellProduct.vue?vue&type=script&lang=js&"
export * from "./BestsellProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e19777b",
  null
  
)

export default component.exports